import React from 'react';
import { UserCircle2, Users, X, Briefcase, Clock } from 'lucide-react';
const TeamMembersModal = ({ team, onClose, translations }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 p-6">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <Users className="w-8 h-8 text-white" />
              <div>
                <h2 className="text-2xl font-bold text-white">{team.name}</h2>
                <p className="text-indigo-100 text-sm">
                  {team.employees.length} {translations("teams.count")}{team.employees.length !== 1 ? 's' : ''}
                </p>
              </div>
            </div>
            <button 
              onClick={onClose}
              className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>
        
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          {team.employees.length === 0 ? (
            <div className="text-center py-12">
              <Users className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500 text-lg">{translations("teams.members.empty")}</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 gap-6">
              {team.employees.map((member, index) => (
                <div 
                  key={index} 
                  className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:shadow-lg hover:border-indigo-100 transition-all duration-200"
                >
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="relative">
                      <UserCircle2 className="w-14 h-14 text-indigo-600" />
                      <div className="absolute bottom-0 right-0 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">{member.name}</h3>
                      <p className="text-sm text-gray-500 flex items-center gap-1">
                        <Briefcase className="w-4 h-4" />
                        {translations("teams.members.employeeHash")}{member.number}
                      </p>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex items-center gap-3 text-gray-600">
                      <Clock className="w-5 h-5 text-indigo-500" />
                      <div className="flex-1">
                        <div className="flex justify-between items-center mb-1">
                          <span className="text-sm">{translations("teams.members.weeklyHours")}</span>
                          <span className="font-semibold text-gray-900">{member.wkl_Wrk_Load / 10}h</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div 
                            className="bg-indigo-500 h-2 rounded-full" 
                            style={{ width: `${(member.wkl_Wrk_Load / 10 / 40) * 100}%` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-3 text-gray-600">
                      <Clock className="w-5 h-5 text-indigo-500" />
                      <div className="flex-1">
                        <div className="flex justify-between items-center mb-1">
                          <span className="text-sm">{translations("teams.members.dailyHours")}</span>
                          <span className="font-semibold text-gray-900">{member.day_WI / 10}h</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div 
                            className="bg-indigo-500 h-2 rounded-full" 
                            style={{ width: `${(member.day_WI / 10 / 8) * 100}%` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamMembersModal;